export default {
    auth: {
        login: {
            title: '老师登录',
            buttons: {
                enter: '登录',
                chathess: 'Chathess 登录',
                register: '注册',
            },
        },
    },
    register: {
        title: '注册',
        description: '请输入注册所需的信息',
        chathessId: 'Chathess ID',
        accountInfo: '账户信息',
        accessId: '用户名',
        password: '密码',
        passwordConfirm: '确认密码',
        buttons: {
            cancel: '取消',
            register: '注册',
        },
    },
    home: {
        title: '点击活动开始学习。',
    },
    self: {
        title: '自学模式状态',
        clear: '全部完成！',
        tabs: {
            all: '查看全部',
            completed: '已完成的学生',
            inProgress: '进行中的学生',
        },
        noStudent: ({ values }: { values: { tab: string } }) => {
            const { tab } = values;

            if (tab === 'completed') {
                return '没有已完成的学生。';
            } else if (tab === 'in_progress') {
                return '没有进行中的学生。';
            } else {
                return '没有学生。';
            }
        },
        table: {
            name: '姓名',
            progress: '进度',
            module: '模块',
            time: '所用时间',
        },
    },
};
